// DOM element references for UI components

// Auth panel
export const authPanel = document.getElementById('auth-panel')!
export const loginBtn = document.getElementById('login-btn')!

// Loading overlay
export const loadingOverlay = document.getElementById('loading-overlay')!
export const loadingStatus = document.getElementById('loading-status')!
export const progressBar = document.getElementById('progress-bar')!
export const progressText = document.getElementById('progress-text')!

// Canvas
export const canvasContainer = document.getElementById('canvas-container')!

// Info panel
export const infoPanel = document.getElementById('info-panel')!
export const gardenNameEl = document.getElementById('garden-name')!
export const plantCountEl = document.getElementById('plant-count')!
export const buildingCountEl = document.getElementById('building-count')!
export const appVersionEl = document.getElementById('app-version')!

// Controls
export const controlsHint = document.getElementById('controls-hint')!
export const togglePanel = document.getElementById('toggle-panel')!
export const viewToggle = document.getElementById('view-toggle')!
export const walkToggle = document.getElementById('walk-toggle')!
export const walkRow = document.getElementById('walk-row')!

// Layer panel
export const layerPanel = document.getElementById('layer-panel')!
export const layerPlantsBtn = document.getElementById('layer-plants-btn')!
export const layerBuildingsBtn = document.getElementById('layer-buildings-btn')!
export const layerGroundBtn = document.getElementById('layer-ground-btn')!
export const layerMetadataBtn = document.getElementById('layer-metadata-btn')!

// Tool panel
export const toolPanel = document.getElementById('tool-panel')!
export const toolHandBtn = document.getElementById('tool-hand-btn')!
export const toolPointerBtn = document.getElementById('tool-pointer-btn')!

// Garden selector
export const gardenSelector = document.getElementById('garden-selector')!
export const gardenList = document.getElementById('garden-list')!

// Top bar (new UI)
export const topBar = document.getElementById('top-bar')!
export const topBarGardenName = document.getElementById('top-bar-garden-name') as HTMLInputElement
export const topBarGardenChevron = document.getElementById('top-bar-garden-chevron')!
export const topBarDescDropdown = document.getElementById('top-bar-desc-dropdown')!
export const topBarDescTextarea = document.getElementById('top-bar-desc-textarea') as HTMLTextAreaElement
export const topBar2DBtn = document.getElementById('top-bar-2d-btn')!
export const topBar3DBtn = document.getElementById('top-bar-3d-btn')!
export const topBarWalkBtn = document.getElementById('top-bar-walk-btn')!
export const topBarLayerMapBtn = document.getElementById('top-bar-layer-map-btn')!
export const topBarLayerMetadataBtn = document.getElementById('top-bar-layer-metadata-btn')!
export const topBarLayerGroundBtn = document.getElementById('top-bar-layer-ground-btn')!
export const topBarLayerBuildingsBtn = document.getElementById('top-bar-layer-buildings-btn')!
export const topBarLayerPlantsBtn = document.getElementById('top-bar-layer-plants-btn')!
export const topBarExitBtn = document.getElementById('top-bar-exit-btn')!
export const topBarHelpBtn = document.getElementById('top-bar-help-btn')!
export const topBarSettingsBtn = document.getElementById('top-bar-settings-btn')!

// Top bar - file operations (edit mode only)
export const topBarFileOpsGroup = document.getElementById('top-bar-file-ops-group')!
export const topBarFileOpsDivider = document.getElementById('top-bar-file-ops-divider')!
export const topBarNewBtn = document.getElementById('top-bar-new-btn') as HTMLButtonElement
export const topBarSaveAsBtn = document.getElementById('top-bar-save-as-btn') as HTMLButtonElement
export const topBarSaveBtn = document.getElementById('top-bar-save-btn') as HTMLButtonElement
export const topBarSaveDot = document.getElementById('top-bar-save-dot')!

// Top bar - undo/redo (edit mode only)
export const topBarUndoGroup = document.getElementById('top-bar-undo-group')!
export const topBarUndoDivider = document.getElementById('top-bar-undo-divider')!
export const topBarUndoBtn = document.getElementById('top-bar-undo-btn') as HTMLButtonElement
export const topBarRedoBtn = document.getElementById('top-bar-redo-btn') as HTMLButtonElement

// Top bar - clipboard (edit mode only)
export const topBarClipboardGroup = document.getElementById('top-bar-clipboard-group')!
export const topBarClipboardDivider = document.getElementById('top-bar-clipboard-divider')!
export const topBarCopyBtn = document.getElementById('top-bar-copy-btn') as HTMLButtonElement
export const topBarPasteBtn = document.getElementById('top-bar-paste-btn') as HTMLButtonElement

// Top bar - tool mode (edit mode only)
export const topBarToolModeGroup = document.getElementById('top-bar-tool-mode-group')!
export const topBarToolModeDivider = document.getElementById('top-bar-tool-mode-divider')!
export const topBarPanBtn = document.getElementById('top-bar-pan-btn')!
export const topBarSelectBtn = document.getElementById('top-bar-select-btn')!
export const topBarRulerBtn = document.getElementById('top-bar-ruler-btn')!

// Bottom bar (new UI)
export const bottomBarHintText = document.getElementById('bottom-bar-hint-text')!
export const bottomBarInfo = document.getElementById('bottom-bar-info')!
export const bottomBarInfoSpacer = document.getElementById('bottom-bar-info-spacer')!
export const demoBadge = document.getElementById('demo-badge')!

// Canvas controls (compass + zoom)
export const canvasControls = document.getElementById('canvas-controls')!
export const compassBtn = document.getElementById('compass-btn')!
export const compassInner = document.getElementById('compass-inner')!
export const zoomInBtn = document.getElementById('zoom-in-btn') as HTMLButtonElement
export const zoomOutBtn = document.getElementById('zoom-out-btn') as HTMLButtonElement

// Left panel container (new UI)
export const leftPanelContainer = document.getElementById('left-panel-container')!
